export default __webpack_public_path__ + "static/media/user_icon.234ac6be.svg";